angular.module('user', [
    'event',
    'inetsys.modal',
    'sharecrf-auth',
    'sharecrf-url',
]);
